/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Bu dosya QubePro ekosisteminde ortak (global) standarttır.
 * Tek kaynak `qubepro-core` reposudur; uydu repolarda kalıcı değişiklik yapılmaz.
 * Değişiklik gerekiyorsa Core'da güncellenir ve senkron ile diğer repolara yayılır.
 */

import {
  isProductTourRevealSurface,
  type ProductTourRevealSurface,
} from './product-tour.utils';

export const PRODUCT_TOUR_SURFACE_REQUEST_EVENT = 'qubepro:product-tour:surface-request';

export type ProductTourSurfaceRequest = ProductTourRevealSurface | null;

export function requestProductTourSurface(surface: ProductTourSurfaceRequest): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(PRODUCT_TOUR_SURFACE_REQUEST_EVENT, {
    detail: { surface },
  }));
}

export function subscribeProductTourSurface(
  listener: (surface: ProductTourSurfaceRequest) => void,
): () => void {
  if (typeof window === 'undefined') return () => undefined;

  const handleRequest = (event: Event) => {
    const surface = (event as CustomEvent<{ surface?: unknown }>).detail?.surface;
    if (surface === null) {
      listener(null);
      return;
    }
    if (isProductTourRevealSurface(surface)) {
      listener(surface);
    }
  };

  window.addEventListener(PRODUCT_TOUR_SURFACE_REQUEST_EVENT, handleRequest);
  return () => window.removeEventListener(PRODUCT_TOUR_SURFACE_REQUEST_EVENT, handleRequest);
}
